import { render } from "./edit_promotion.vue?vue&type=template&id=c25c89e2"
import script from "./edit_promotion.vue?vue&type=script&lang=js"
export * from "./edit_promotion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__